/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierFreeMaxStudentsSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_FREE_MAX_STUDENTS')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class TierFreeMaxStudentsSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierFreeMaxStudentsSettingParser.decode(input).map(res => new TierFreeMaxStudentsSetting(res));
    }
    static unsafeDecode(input) {
        return TierFreeMaxStudentsSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierFreeMaxStudentsSettingParser.encode(data);
    }
    static schema() {
        return TierFreeMaxStudentsSettingParser.schema();
    }
}
